import { useQuery } from '@tanstack/react-query';
import { useDataChainId } from '@ui/hooks/datachain';
import { FALLBACK_ADDRESS } from '@ui/services/contract/constants';
import type { Address } from '@ui/types/alias';
import { useAccount, usePublicClient } from 'wagmi';

import { decreaseOrdersQuery } from './query';

export const useDecreaseOrders = ({
  positionHash,
  fromBlock,
  userAddress,
}: {
  positionHash?: Address;
  fromBlock?: bigint;
  userAddress?: Address;
} = {}) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });
  const { address } = useAccount();
  const user = userAddress ?? address;

  return useQuery({
    enabled: !!user && !!client?.uid,
    queryKey: decreaseOrdersQuery.getQueryKey({
      chainId,
      user: user ?? FALLBACK_ADDRESS,
      positionHash,
      clientUid: client?.uid,
    }),
    queryFn: decreaseOrdersQuery.getQueryFn({
      chainId,
      client,
      user: user ?? FALLBACK_ADDRESS,
      positionHash,
      fromBlock,
    }),
  });
};

